var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterbodiesProposed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#9CD7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 22.2244C45.5225 21.5644 43.9925 19.9444 42.725 18.1407C41.93 17.0119 40.1844 17.0813 39.3219 18.165C37.3531 20.6438 34.4094 22.6257 29.75 22.6257C25.0494 22.6257 22.0963 20.1038 20.1256 17.73C19.3006 16.7363 17.7256 16.7513 17.0038 17.8107C15.6875 19.7419 14.1575 21.5232 11 22.2244M48.5 40.9744C45.5225 40.3144 43.9925 38.6944 42.725 36.8907C41.93 35.7619 40.1844 35.8294 39.3219 36.915C37.3531 39.3938 34.4094 41.3757 29.75 41.3757C25.0494 41.3757 22.0963 38.8538 20.1256 36.48C19.3006 35.4863 17.7256 35.5013 17.0038 36.5607C15.6894 38.4919 14.1575 40.2732 11 40.9744M48.5 31.5994C45.5225 30.9394 43.9925 29.3194 42.725 27.5157C41.93 26.3869 40.1844 26.4544 39.3219 27.54C37.3531 30.0188 34.4094 32.0007 29.75 32.0007C25.0494 32.0007 22.0963 29.4788 20.1256 27.105C19.3006 26.1113 17.7256 26.1263 17.0038 27.1857C15.6894 29.1169 14.1575 30.8982 11 31.5994",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterbodiesProposed);
export default __webpack_public_path__ + "static/media/waterbodies_proposed.04cdd28f96e23b100c8d176809638d0b.svg";
export { ForwardRef as ReactComponent };